 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP202563 from '@/components/chap202563'
 import CHAP202550 from '@/components/chap202550'
 import CHAP202548 from '@/components/chap202548'
 import CHAP202547 from '@/components/chap202547'
 import CHAP202552 from '@/components/chap202552'
 import CHAP202551 from '@/components/chap202551'
 import CHAP202564 from '@/components/chap202564'
 import CHAP202565 from '@/components/chap202565'
 import CHAP202566 from '@/components/chap202566'
 import CHAP202560 from '@/components/chap202560'
 import CHAP202542 from '@/components/chap202542'
 import CHAP202561 from '@/components/chap202561'
 import CHAP202567 from '@/components/chap202567'
 import CHAP202553 from '@/components/chap202553'
 import CHAP202559 from '@/components/chap202559'
 import CHAP202549 from '@/components/chap202549'
 import CHAP202544 from '@/components/chap202544'
 import CHAP202543 from '@/components/chap202543'
 import CHAP202562 from '@/components/chap202562'
 import CHAP202545 from '@/components/chap202545'
 import CHAP202555 from '@/components/chap202555'
 import CHAP202556 from '@/components/chap202556'
 import CHAP202568 from '@/components/chap202568'
 import CHAP202554 from '@/components/chap202554'
 import CHAP202557 from '@/components/chap202557'
 import LOVE_2 from '@/components/love_2'
 import CHAP202546 from '@/components/chap202546'
 import CHAP202558 from '@/components/chap202558'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap202563",
 			"name" : "chap202563",
 			"component" : CHAP202563
 		},
 		{
 			"path" : "/chap202550",
 			"name" : "chap202550",
 			"component" : CHAP202550
 		},
 		{
 			"path" : "/chap202548",
 			"name" : "chap202548",
 			"component" : CHAP202548
 		},
 		{
 			"path" : "/chap202547",
 			"name" : "chap202547",
 			"component" : CHAP202547
 		},
 		{
 			"path" : "/chap202552",
 			"name" : "chap202552",
 			"component" : CHAP202552
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js